// INV
document.querySelectorAll('.menu-link .text-animation--underline-in-header').forEach(function(el) {
if (el.textContent.includes("Probiersets")) {
    el.style.fontWeight = "bold";
    el.style.color = "#c7b15d";
    el.style.textDecoration = "underline";
}
if (el.textContent.includes("PREMIUM BOX")) {
    el.style.fontWeight = "bold";
    el.style.color = "#c7b15d";
}
});
